'use client';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { useCheckSpotOnly } from '@flipster/features/src/shared/regulation';
import { useIsWebview } from '@flipster/features/src/shared/webview';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';
import { Styles, css, cx } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { MarketingButton } from '../_button';

interface Props {
  css?: Styles;
  title?: string | null;
  buttonNotLoggedIn: {
    text: string;
    url: string;
    appLocator: string;
  };
  buttonLoggedIn: {
    text: string;
    url: string;
    appLocator: string;
  };
}

const Footer = ({ css: cssProps, title, buttonNotLoggedIn, buttonLoggedIn }: Props) => {
  const isMounted = useMounted();
  const { isCookieLoggedIn } = useAuth();
  const isWebview = useIsWebview();
  const isVara = useCheckSpotOnly();

  /**
   * TO-BE footer 표시 여부
   * isCookieLoggedIn이 false이고 appDownload이 있고 isVara와 isWebview가 false일 때
   */
  const showAppDownloadBeforeLoggedIn = !isCookieLoggedIn && !isVara && !isWebview;

  if (isMounted && showAppDownloadBeforeLoggedIn) return null;

  return (
    <BaseFooter css={cssProps} title={title} buttonNotLoggedIn={buttonNotLoggedIn} buttonLoggedIn={buttonLoggedIn} />
  );
};

export const BaseFooter = ({ css: cssProps, title, buttonNotLoggedIn, buttonLoggedIn }: Props) => {
  return (
    <section
      className={cx(
        css({
          h: [320, 400],
          pos: 'relative',
          bgColor: 'background.default.level-1',
        }),
        css(cssProps),
      )}
    >
      <div className={stack({ textAlign: 'center', align: 'center' })}>
        <h2
          className={css({
            textStyle: 'Display/XL',
            color: 'inverse.white',
            whiteSpace: 'pre-line',
            textWrap: 'balance',
            mb: [24, 32],
          })}
          data-section-type='footer'
        >
          {title}
        </h2>
        <MarketingButton section='footer' defaultJson={buttonNotLoggedIn} loggedInJson={buttonLoggedIn} />
      </div>
    </section>
  );
};

export default Footer;
